import { createTheme } from "@mui/material/styles";

const Theme = createTheme({
  cssVariables: {
    colorSchemeSelector: "data-mui-color-scheme",
    cssVarPrefix: "junction-core",
  },
  palette: {
    mode: "light",

    primary: { main: "#2B4A6F" },
    secondary: { main: "#AA7E39" },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "filled",
        // color: "textFieldLabelColor",
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "var(--junction-core-palette-primary-A100)",
          },
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: ({ theme }) => ({
          color: theme.palette.primary.light,
        }),
      },
    },
  },
});

export default Theme;
